import { CommonModule } from "@angular/common";
import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";
import { NgModule } from "@angular/core";

import { AuthModule } from "./modules/auth/auth.module";
import { DashboardModule } from "./modules/dashboard/dashboard.module";
import { HomePageComponent } from "./pages/home/home.component";
import { SharedModule } from "@serasa/shared/shared.module";
import { UsersModule } from "./modules/users/user.module";
import { HeaderComponent } from "../shared/components/header/header.component";
import { BusinessInfoComponent } from "./modules/dashboard/components/business-info/business-info.component";
import { UserIdleModule } from "./modules/users/components/user-idle/user-idle.module";

@NgModule({ declarations: [HomePageComponent],
    exports: [DashboardModule, UsersModule, AuthModule, UserIdleModule], imports: [AuthModule,
        CommonModule,
        DashboardModule,
        SharedModule,
        UsersModule,
        HeaderComponent,
        UserIdleModule,
        BusinessInfoComponent], providers: [provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule { }
